function getFeatureImageUrl(index: number): string {
  const urls = [
    "https://readdy.ai/api/search-image?query=Clean%20minimal%20workspace%20with%20organized%20product%20catalog%20cards%20spread%20across%20a%20light%20wooden%20desk%20surface%20warm%20morning%20light%20creating%20soft%20shadows%20modern%20digital%20shopping%20concept%20photography%20with%20curated%20product%20curation%20aesthetic&width=200&height=200&seq=pandabuy-feature-database-v2&orientation=squarish",
    "https://readdy.ai/api/search-image?query=Calendar%20and%20clock%20arrangement%20with%20fresh%20coffee%20on%20bright%20white%20desk%20surface%20surrounded%20by%20small%20fashion%20accessory%20samples%20conveying%20daily%20updates%20concept%20soft%20natural%20daylight%20clean%20modern%20product%20photography%20with%20organized%20systematic%20aesthetic&width=200&height=200&seq=pandabuy-feature-daily-v2&orientation=squarish",
    "https://readdy.ai/api/search-image?query=Magnifying%20glass%20hovering%20over%20colorful%20product%20tags%20and%20labels%20arranged%20on%20light%20grey%20surface%20with%20soft%20directional%20lighting%20creative%20search%20and%20filter%20concept%20photography%20clean%20modern%20composition%20with%20bright%20airy%20feel&width=200&height=200&seq=pandabuy-feature-search-v2&orientation=squarish",
    "https://readdy.ai/api/search-image?query=Smartphone%20displaying%20elegant%20fashion%20product%20grid%20interface%20on%20screen%20placed%20beside%20a%20steaming%20cup%20of%20tea%20and%20small%20succulent%20plant%20on%20warm%20wooden%20surface%20natural%20window%20light%20minimal%20mobile%20shopping%20concept%20photography%20with%20lifestyle%20aesthetic&width=200&height=200&seq=pandabuy-feature-mobile-v2&orientation=squarish",
    "https://readdy.ai/api/search-image?query=Checkmark%20badge%20and%20shield%20icon%20themed%20arrangement%20with%20small%20product%20samples%20including%20a%20watch%20and%20wallet%20on%20light%20marble%20surface%20conveying%20trust%20and%20verification%20concept%20clean%20professional%20photography%20with%20reassuring%20warm%20tones&width=200&height=200&seq=pandabuy-feature-verified-v2&orientation=squarish",
    "https://readdy.ai/api/search-image?query=Price%20tags%20and%20calculator%20alongside%20folded%20clothing%20items%20and%20accessories%20on%20soft%20linen%20background%20with%20warm%20morning%20sunlight%20comparison%20shopping%20concept%20photography%20clean%20organized%20layout%20with%20thoughtful%20consumer%20focused%20aesthetic&width=200&height=200&seq=pandabuy-feature-price-v2&orientation=squarish"
  ];
  return urls[index] || urls[0];
}

export default function AboutSection() {
  const features = [
    { icon: "ri-database-2-line", label: "1000+ Curated Items", imageIndex: 0 },
    { icon: "ri-refresh-line", label: "Daily Updated Lists", imageIndex: 1 },
    { icon: "ri-search-line", label: "Fast Search & Filter", imageIndex: 2 },
    { icon: "ri-smartphone-line", label: "Mobile Optimized", imageIndex: 3 },
    { icon: "ri-shield-check-line", label: "Community Verified", imageIndex: 4 },
    { icon: "ri-price-tag-3-line", label: "Price Compared", imageIndex: 5 },
  ];

  return (
    <section className="relative w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        {/* Capsule tag */}
        <span className="inline-block px-4 py-1.5 text-xs font-medium text-foreground-600 border border-foreground-200 rounded-full mb-6">
          Structured Shopping Index
        </span>

        {/* Title */}
        <h2 className="font-heading text-3xl md:text-5xl font-light text-foreground-950 leading-tight tracking-tight">
          Curated
          <span className="inline-flex items-center mx-1 align-middle">
            <i className="ri-shopping-bag-3-line text-primary-500 text-2xl md:text-4xl"></i>
          </span>
          Pandabuy
          <br />
          Sheet
          <span className="inline-flex items-center mx-1 align-middle">
            <i className="ri-t-shirt-line text-accent-500 text-2xl md:text-4xl"></i>
          </span>
          Index
        </h2>

        {/* Description */}
        <p className="mt-8 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
          The <strong>Pandabuy Spreadsheet</strong> index is a carefully organized, searchable database designed to
          help shoppers discover verified product listings without the hassle of digging through
          scattered community spreadsheets. Organized by category, quality tier, and popularity,
          this platform makes <strong>Pandabuy Spreadsheet</strong> shopping faster and smarter
          than traditional browsing methods.
        </p>

        {/* Feature highlights */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {features.map((item) => (
            <div
              key={item.label}
              className="flex flex-col items-center gap-3 p-4 md:p-5 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors duration-200 group cursor-default"
            >
              {/* Feature Image */}
              <div className="w-full aspect-[4/3] rounded-md overflow-hidden mb-1">
                <img
                  src={getFeatureImageUrl(item.imageIndex)}
                  alt={"Pandabuy Spreadsheet " + item.label}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              {/* Icon + Label */}
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50">
                  <i className={`${item.icon} text-base text-primary-500`}></i>
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-700 whitespace-nowrap">{item.label}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <p className="mt-10 text-xs text-foreground-400 leading-relaxed max-w-xl mx-auto">
          We are not affiliated with Pandabuy. All <strong>Pandabuy Spreadsheet</strong> data
          is for informational purposes only. Users are responsible for their own purchasing
          decisions and regional compliance.
        </p>
      </div>
    </section>
  );
}